// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"795":"b6e37a625382174b","981":"485c7d639e4bdf24"}[chunkId] + ".js";
};